import { ProveedorReferenceCode } from "./ProveedorReferenceCode";
import { ProveedorTagXML } from "./ProveedorTagXML";

export class Proveedor {
	public proveedorId: string;
	public rut: number;
	public dv: string;
	public razonSocial: string;
	public giro: string;
	public dirPart: string;
	public dirFact: string;
	public correoPar: string;
	public ciudad: string;
	public comuna: string;
	public rutProveedor: string;
	public emisorId: string;
	public correoFact: string;
	public xmlTagsRules: ProveedorTagXML[];
	public codeReferenceRules: ProveedorReferenceCode[];
	public acuseReciboAutomatico: boolean;
	public activo: boolean;

	showActions?: boolean;
}
